// extracted by mini-css-extract-plugin
export default {"searchActive":"PageLayout_searchActive__S6QQf","searchHidden":"PageLayout_searchHidden__D-Kvr"};